import { Element } from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { Dispatch, SetStateAction, memo } from 'react';
import { TTabType } from './constant';
import styles from './search.module.scss';

interface IProps {
    setActiveTab: Dispatch<SetStateAction<TTabType>>;
    activeTab: TTabType;
    tabList: TTabType[];
}

const TAB_ITEMS = [
    {
        id: 'news',
        name: 'Tin Tức',
    },
    {
        id: 'teams',
        name: 'Đội',
    },
    {
        id: 'tournaments',
        name: 'Giải đấu',
    },
    {
        id: 'players',
        name: 'Cầu thủ',
    },
] as { id: TTabType; name: string }[];

export function SearchTabs({ setActiveTab, activeTab, tabList = [] }: IProps) {
    if (!tabList.length) {
        return null;
    }

    return (
        <Element className={styles['search-tabs']}>
            {tabList.map((item, index) => {
                return (
                    <Element
                        className={cn(styles['search-tabs-item'], {
                            [styles['is-active']]: activeTab === item,
                        })}
                        onClick={() => setActiveTab(item)}
                        key={index}
                    >
                        {TAB_ITEMS.filter((tab) => tab.id === item)[0]?.name}
                    </Element>
                );
            })}
        </Element>
    );
}

export default memo(SearchTabs);
